import React, { } from 'react';
import { Box } from '@chakra-ui/react'
// Components
import Spinner from '../spinner/spinner';

const Loading = () => {
    return(
      <Box
        style={{
          position: 'absolute', 
          top: 0,    
          left: 0,  
          height: '100%',
          width: '100%',
          display: 'flex',          // Flexbox
          justifyContent: 'center', // Centers horizontally
          alignItems: 'center',     // Centers vertically
        }}
      >
        <Spinner />
      </Box>
    );    
}

export default Loading;
